import React from 'react';
import { Form } from 'react-bootstrap';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { ProdutoCatalogo, TipoProdutoCatalogo, VariedadeProdutoCatalogo } from '../../types/estoque';
import { catalogoProdutosService, categoriasProdutoService } from '../../services';
import { makeOptionLoader } from '../../utils/optionLoaders';

const tipoOptions: { label: string; value: TipoProdutoCatalogo }[] = [
  { label: 'Madeira', value: 'MADEIRA' },
  { label: 'Produto Acabado', value: 'PALLET' },
  { label: 'Insumo', value: 'INSUMO' },
];

const variedadeOptions: { label: string; value: VariedadeProdutoCatalogo }[] = [
  { label: 'Primeira', value: '1' },
  { label: 'Segunda', value: '2' },
  { label: 'N/A', value: 'NA' },
];

const fields: ResourceField<ProdutoCatalogo>[] = [
  { name: 'codigo', label: 'Código', required: true },
  { name: 'descricao', label: 'Descrição', required: true },
  {
    name: 'tipo',
    label: 'Tipo',
    type: 'select',
    options: tipoOptions,
    required: true,
  },
  {
    name: 'categoria_produto',
    label: 'Categoria',
    type: 'async-select',
    valueType: 'number',
    required: true,
    loadOptions: makeOptionLoader(
      categoriasProdutoService.list,
      (item: any) => `${item.nome ?? ''} ${item.descricao ?? ''}`.trim(),
    ),
  },
  { name: 'unidade', label: 'Unidade de medida', required: true, helperText: 'Ex: UN, M3, KG' },
  { name: 'unidade_comercial', label: 'Unidade comercial', helperText: 'Ex: CX, FARDO (opcional)' },
  {
    name: 'fator_conversao',
    label: 'Fator de conversão',
    type: 'number',
    valueType: 'number',
    helperText: 'Qtd de UN base por unidade_comercial. Padrão: 1.0',
  },
  {
    name: 'variedade',
    label: 'Variedade',
    type: 'select',
    options: variedadeOptions,
    required: true,
  },
  { name: 'altura_mm', label: 'Altura (mm)', type: 'number', valueType: 'number' },
  { name: 'largura_mm', label: 'Largura (mm)', type: 'number', valueType: 'number' },
  { name: 'comprimento_mm', label: 'Comprimento (mm)', type: 'number', valueType: 'number' },
  { name: 'quantidade_caixa', label: 'Quantidade de caixas', type: 'number', valueType: 'number', helperText: 'Para MI. Padrão: 0.0' },
  { name: 'quantidade_por_caixa', label: 'Quantidade por caixa', type: 'number', valueType: 'number', helperText: 'Para MI. Padrão: 0.0' },
  { name: 'estoque_minimo', label: 'Estoque mínimo', type: 'number', valueType: 'number', helperText: 'Estoque de segurança. Padrão: 0.0' },
  { name: 'estoque_maximo', label: 'Estoque máximo', type: 'number', valueType: 'number', helperText: 'Estoque máximo desejado. Padrão: 0.0' },
  { name: 'localizacao', label: 'Localização' },
  { name: 'peso_unitario_kg', label: 'Peso unitário (kg)', type: 'number', valueType: 'number', helperText: 'Padrão: 0' },
  {
    name: 'tempo_preparo_min',
    label: 'Tempo de preparo (min)',
    type: 'number',
    valueType: 'number',
    helperText: 'Tempo de preparo/produção por unidade. Padrão: 0.0',
  },
  {
    name: 'venda_autorizada',
    label: 'Venda autorizada',
    render: ({ value, onChange }) => (
      <Form.Group controlId="produto-venda-autorizada">
        <Form.Check
          type="switch"
          label="Permitir venda"
          checked={Boolean(value)}
          onChange={(e) => onChange(e.target.checked)}
        />
      </Form.Group>
    ),
  },
  {
    name: 'movimenta_estoque',
    label: 'Movimenta estoque',
    render: ({ value, onChange }) => (
      <Form.Check
        type="switch"
        label="Movimenta estoque"
        checked={Boolean(value)}
        onChange={(e) => onChange(e.target.checked)}
      />
    ),
  },
  {
    name: 'produzido_internamente',
    label: 'Produzido internamente',
    render: ({ value, onChange }) => (
      <Form.Check
        type="switch"
        label="Produzido internamente"
        checked={Boolean(value)}
        onChange={(e) => onChange(e.target.checked)}
      />
    ),
  },
  {
    name: 'tem_ficha_tecnica',
    label: 'Tem ficha tecnica',
    render: ({ value, onChange }) => (
      <Form.Check
        type="switch"
        label="Tem ficha tecnica"
        checked={Boolean(value)}
        onChange={(e) => onChange(e.target.checked)}
      />
    ),
  },
];

export const ProdutosFormPage: React.FC = () => (
  <ResourceFormPage
    title="Produto"
    description="Cadastro de produtos (catalogo)."
    fields={fields}
    service={catalogoProdutosService}
    redirectPath="/admin/cadastro/produtos"
    cancelPath="/admin/cadastro/produtos"
    initialValues={{ venda_autorizada: false }}
  />
);
